<div class="row text-center ma-font-setup">
  <div class="col" [ngClass]="{ 'margin-bottom mb24': !isAcmic }"> 
    <ng-container *ngIf="isAcmic">
    <div class="header-icon full-icon">
        <create-company-icon-svg></create-company-icon-svg>
    </div>
  </ng-container>
    <h1 class="title-copy commercialAccheader">{{ 'CREATE_COMMERCIAL_POLICY_ACCOUNT' | translate }}</h1> 
    <ng-container *ngIf="!isAcmic">
    <div class="content-w-320">{{ "ENTER_COMPANY_NAME" | translate }}</div>
  </ng-container>
  </div>
</div>
<form 
  [formGroup]="createCommercialAcForm" 
  name="createCommercialAcForm" class="ma-commercial-form"
  (ngSubmit)="createCommercialAcForm.valid && createCommercialAccount()">
    <div *ngFor="let input of inputs; index as index; " class="input" [ngClass]="{'companyInput': input?.key === 'createAc_companyName'}">
      <mapfre-validation [input]="input" [form]="createCommercialAcForm" (commercialInputValidationCheck)="isValidInput($event, input?.key)"></mapfre-validation>
      <mapfre-modal *ngIf="input?.key === 'createAc_companyName' && isInValidCompanyInput"
        [modalOptions]="companyInvoiceModalOptions" class="cusLable">
        <div class="modal-body no-padding-top">
          <hr class="margin-bottom mb24" />
          <div class="margin-bottom mb24">
            <img src="./assets/img/images/invoice_company.png" alt="company invoice">
          </div>
        </div>
      </mapfre-modal>
    </div>
    <div class="disclaimer disclaimer-small-size legal margin-bottom mb24">
      {{ 'CREATE_ACCOUNT_LEGAL_ONE' | translate }}
      <a [ngClass]="{ 'corporate-red': !isAcmic }"  href="https://www.mapfreinsurance.com/en/terms-conditions/" target="_blank" rel="noopener">{{ 'CREATE_ACCOUNT_LEGAL_TWO' | translate }}</a>
      {{ 'CREATE_ACCOUNT_LEGAL_THREE' | translate }}
      <a [ngClass]="{ 'corporate-red': !isAcmic }" href="https://www.mapfreinsurance.com/en/privacy-policy/" target="_blank" rel="noopener">{{ 'CREATE_ACCOUNT_LEGAL_FOUR' | translate }}.</a>
    </div>
    <div class="row group-button text-center">
      <div class="col">
        <mapfre-button [ngClass]="{'custom_loader':loader}"
          [additionalClasses]="'basic primary large-btn'"
          [disabledValue]="createCommercialAcForm.valid && !loader" 
          [inputType]="'submit'"
          [translateValue]="'CONTINUE' | translate"
        ></mapfre-button>
      </div>
    </div>
</form>
<div class="row text-center margin-top mt24">
  <div class="col">
      <mapfre-button
        additionalClasses="link-button red-link small w-100 button-border-red"
        [backIcon]="'./assets/img/icons/back-arrow-red.png'"
        [iconClasses]="'align-middle'"
        [routerLink]="['/signup']"
        [showIconsCustom]="true"
        (click)="goBack()"
      >  {{ 'BACK' | translate }}
      </mapfre-button>    
  </div>
</div>